"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractIntervalEnum = void 0;
/** Период повторения занятий для контракта на услуги */
var UserServiceContractIntervalEnum;
(function (UserServiceContractIntervalEnum) {
  /** Не повторяется */
  UserServiceContractIntervalEnum[UserServiceContractIntervalEnum["none"] = 1] = "none";
  /** Повторяется с недельными интервалами */
  UserServiceContractIntervalEnum[UserServiceContractIntervalEnum["weekly"] = 10] = "weekly";
})(UserServiceContractIntervalEnum = exports.UserServiceContractIntervalEnum || (exports.UserServiceContractIntervalEnum = {}));
